/**
 * Compact inline select for a MARC indicator value.
 * Renders as a small labeled select in the MarcFieldPanel header.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { resolveLabel } from '../renderer/labelResolver';
var wrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
};
var labelTextStyle = {
    color: '#666',
    whiteSpace: 'nowrap',
};
var selectStyle = {
    fontSize: '12px',
    padding: '2px 4px',
    border: '1px solid #ccc',
    borderRadius: '3px',
    background: '#fff',
    color: '#333',
    minWidth: '40px',
};
var IndicatorSelect = function (_a) {
    var indicatorDef = _a.indicatorDef, value = _a.value, onChange = _a.onChange, inputId = _a.inputId;
    var intl = useIntl();
    return (React.createElement("span", { style: wrapperStyle },
        React.createElement("span", { id: "".concat(inputId, "-label"), style: labelTextStyle }, resolveLabel(indicatorDef, intl)),
        React.createElement("select", { id: inputId, "aria-labelledby": "".concat(inputId, "-label"), style: selectStyle, value: value, onChange: function (e) { return onChange(e.target.value); } }, indicatorDef.options.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value },
            opt.value === ' ' ? '#' : opt.value,
            ' — ',
            resolveLabel(opt, intl))); }))));
};
export default IndicatorSelect;
